module.exports = __webpack_public_path__ + "static/media/ReactTrainingLogo.60ca6a36.png";


//////////////////
// WEBPACK FOOTER
// ./client/ReactTrainingLogo.png
// module id = 266
// module chunks = 0